import getItemStyle from '../../../utils/item-styles';
import timelineDisplayOrder from './timelineDisplayOrder';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments';
import getOffsetTime from '../../../../../utils/getOffsetTime';


/**
 * Returns a tour item based upon the start and end time of the tour, whether there is a meal and where the meal
 * falls within the schedule, and finally whether the tour has overtime.
 * @param {*} tourType
 * @param {*} mealPosition
 * @param {*} resource
 * @param {*} dayType
 * @param {*} tourStartTime
 * @param {*} tourEndTime
 * @param {*} timeSummary
 * @param {*} mealStartTime
 * @param {*} mealEndTime
 */

const generateTour = (tourType, mealPosition, resource, dayType, tourStartTime, tourEndTime, timeSummary, mealStartTime, mealEndTime, overtimeStartTime, timeOffset) => {
  const { rId  } = resource;
  const { rdtId } = dayType;
  const { tourId, notificationComment, tourComment, isApproved } = dayType.tour;

  let hasComment = false;
  if ( ignoreDummyComments(notificationComment || tourComment) ) {
    hasComment = true;
  }
  let isOvertime;
  if ( dayType.title && (dayType.title.includes('Overtime') || dayType.title.includes('OT')) ) {
    isOvertime = true;
  }
  const tourStyle = getItemStyle('tour');
  const overtimeStyle = getItemStyle('overtime');
  let adjustedTour;
  let tour = {
    id: tourId,
    rdtId,
    itemType: 'tour',
    group: rId,
    title: timeSummary,
    start_time: tourStartTime,
    end_time: tourEndTime,
    backgroundColor: dayType.tour.isApproved ? 'gray' : isOvertime ? overtimeStyle.backgroundColor :  '#4F5AF6',
    borderStyle: tourStyle.borderStyle,
    borderColor: !hasComment ? tourStyle.borderColor : 'red',
    timelineDisplayOrder: timelineDisplayOrder.tour,
    isApproved
    };
  if (tourType === 'no-meal-no-overtime') {
    // do nothing...
    return tour;
  } else if (tourType === 'overtime-no-meal') {
    adjustedTour = {
      ...tour,
      end_time: overtimeStartTime
    };
    return adjustedTour;
  } else if (tourType === 'meal-no-overtime') {
      if (mealPosition === 'meal-first') {
        adjustedTour = {
          ...tour,
          start_time: mealEndTime
        };
        return adjustedTour;
      } else if (mealPosition === 'meal-last') {
        adjustedTour = {
          ...tour,
          end_time: mealStartTime
        };
        return adjustedTour;
      } else if (mealPosition === 'meal-middle') {
        adjustedTour = {};
        adjustedTour.preMeal = {
          ...tour,
          id: tourId + '-preMeal',
          end_time: mealStartTime
        };
        adjustedTour.postMeal = {
          ...tour,
          id: tourId + '-postMeal',
          title: '',
          start_time: mealEndTime
        };
        return adjustedTour;
      }
  } else if (tourType === 'meal-before-overtime') {
      if (mealPosition === 'meal-first') {
        adjustedTour = {
          ...tour,
          start_time: mealEndTime,
          end_time: overtimeStartTime
        };
        return adjustedTour;
      } else if (mealPosition === 'meal-last') {
        adjustedTour = {
          ...tour,
          end_time: mealStartTime
        };
        return adjustedTour;
      } else if (mealPosition === 'meal-middle') {
        adjustedTour = {};
        adjustedTour.preMeal = {
          ...tour,
          id: tourId + '-preMeal',
          end_time: mealStartTime
        };
        adjustedTour.postMeal = {
          ...tour,
          id: tourId + '-postMeal',
          title: '',
          start_time: mealEndTime,
          end_time: overtimeStartTime
        };
        return adjustedTour;
      }
  }

}

export default generateTour;




// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/utils/generate-timeline/generateTour.js